import styled from "@emotion/styled"
import React from "react"
import { useTranslation } from "react-i18next"
import { breakPoints, colors } from "../config/theme"
import { Button } from "./Button"

const Base = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 683px;
  padding: 12.5% 12.5% 48px 12.5%;
  background: ${colors.primary};
  color: ${colors.white};
  position: relative;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    min-height: inherit;
  }

  &::after {
    content: "";
    margin: 30px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(120, 120, 120, 0) 100%
    );
    min-height: calc(100% - 60px);
    position: absolute;
    inset: 0;
    z-index: 1;
  }

  & > * {
    z-index: 2;
  }
`

const Title = styled.h1`
  display: block;
  font-family: "Arial";
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 60px;
  letter-spacing: 0.012em;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    font-size: 24px;
    line-height: 32px;
    margin-top: 1em;
  }

  &::before {
    content: "";
    display: block;
    height: 32px;
    width: 108px;
    border-top: 4px solid ${colors.white};
  }
`

const Subtitle = styled.h2`
  font-family: "Arial";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.02em;

  margin-top: 48px;
  margin-bottom: 48px;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    font-size: 16px;
    line-height: 22px;
    margin-top: 2em;
    margin-bottom: 2em;
  }
`

const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

export const Intro: React.FC<{ onStart: () => void }> = ({ onStart }) => {
  const { t } = useTranslation()

  return (
    <Base>
      <div>
        <Title>{t("document.title")}</Title>
        <Subtitle>{t("startQuiz.description")}</Subtitle>
      </div>
      <Buttons>
        <Button inverse onClick={onStart} variant="primary">
          {t("startQuiz.start")}
        </Button>
      </Buttons>
    </Base>
  )
}
